'use es6';

export const RATE_LIMIT_DOCUMENTATION = 'https://developers.hubspot.com/docs/api/usage-details#rate-limits';